import AdminAuthLayout from '../../Layouts/AdminAuthLayout';

import FormLogin from '../../Components/Manager/FormLogin';

function App() {
    return (
        <AdminAuthLayout>
            <div className="mx-auto w-full max-w-[480px]">
                <div className="text-center">
                    <div className="mx-auto 2xl:mb-10 inline-flex items-center w-full max-w-60">
                        <img src={`/assets/img/admin/rometal-logo-blue.svg`} alt="logo" className="block w-full" />
                    </div>

                    <div className="rounded-xl bg-white p-4 shadow-14 lg:p-7 xl:p-12">
                        <span className="mb-1 block text-slate-500 font-medium">Login</span>

                        <h2 className="mb-5 2xl:mb-9 text-3xl font-bold text-primary">Área Restrita</h2>

                        <FormLogin />
                    </div>
                </div>
            </div>
        </AdminAuthLayout>
    );
}

export default App;
